export default function uploadZip(file, type) {
  const body = new FormData()
  body.append('file', file)
  body.append('type', type)
  return fetch(`${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/upload`, {
    credentials: 'include',
    body,
    method: 'POST'
  })
    .then(async response => {
      if (response.ok) {
        this.$notify({
          message: `${this.$t('notification.uploaded')}.`,
          type: 'success'
        })
      } else {
        try {
          const { errors } = await response.json()
          this.$notify({
            message: errors.join('; '),
            type: 'danger'
          })
        } catch (e) {
          throw response.statusText
        }
      }
    })
    .catch(err => {
      this.$notify({
        message: err,
        type: 'danger'
      })
    })
}
